import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import axios from "axios";

import type { IAccountingDataResponse } from "@krea/lender-features/types/accounting-data";

const ACCOUNTING_DATA_STORE_KEY = "accountingData";

const fetchAccountingData = async (loanApplicationId: number) => {
  const response = await axios.get<IAccountingDataResponse>(
    `/api/v1/accounting-service/loan-applications/${loanApplicationId}/accounting-data`,
  );

  return response.data;
};

type ResponseType = Awaited<ReturnType<typeof fetchAccountingData>>;

export const useGetAccountingData = (
  loanApplicationId: number,
  options?: Partial<UseQueryOptions<ResponseType>>,
) =>
  useQuery({
    queryKey: [ACCOUNTING_DATA_STORE_KEY, loanApplicationId],
    queryFn: async () => {
      return await fetchAccountingData(loanApplicationId);
    },
    initialData: {
      balanceSheetEntries: [],
      profitLossEntries: [],
      financialRatioEntries: [],
    },
    ...options,
  });
